import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, light = false }) {
  return (
    <span
      className={
        light
          ? "inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-white backdrop-blur"
          : "overline-tag"
      }
    >
      {children}
    </span>
  );
}

export function Logo({ dark = false, compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="navbar-brand-logo">
      <div className="flex h-10 w-10 overflow-hidden rounded-xl shadow-[0_6px_18px_-6px_rgba(30,63,174,0.45)]">
        <span className="h-full w-1/3 bg-bleu" />
        <span className="h-full w-1/3 bg-white" />
        <span className="h-full w-1/3 bg-rouge" />
      </div>
      <div className="leading-none">
        <p className={`font-display text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
          INTEGRA <span className="text-rouge">FRANCE</span>
        </p>
        {!compact && (
          <p className={`mt-1 text-[10px] font-medium tracking-wide ${dark ? "text-white/60" : "text-slate-400"}`}>
            Votre parcours d'intégration, accompagné par l'IA.
          </p>
        )}
      </div>
    </div>
  );
}
